import React, { Component } from "react";
import { Link } from "react-router-dom";
import Posts from "../components/Posts";
import Follower from "../components/Follower";
import Following from "../components/Following";
import store from "../store";

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFollowing: false,
      userID: 0,
      username: "",
      cmp: "",
      posts: [],
      following: [],
      followers: [],
      followingLite: [],
      bookmarkCount: 0,
      postCount: 0,
      followerCount: 0,
      followingCount: 0,

      requestSent: false,
      postLimit: 0,
      bookmarkLimit: 0,
      scrollTo: 0
    };

    this.beforeListFetch = this.beforeListFetch.bind(this);
    this.fetchPostList = this.fetchPostList.bind(this);
    this.fetchBookmarkedPostList = this.fetchBookmarkedPostList.bind(this);
    this.setScrollPosition = this.setScrollPosition.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.setScrollPosition);

    let urlAry = this.props.match.params.user.split("-");
    document.title = urlAry[0] + " " + urlAry[1];

    fetch(
      `${this.props.apiROOT}user/${this.props.match.params.user}/${this.props.match.params.suser}`
    )
      .then(res => res.json())
      .then(data => {
        this.setState({
          cmp: data.cmp,
          userID: data.user_id,
          posts: data.posts,
          following: data.following,
          followers: data.followers,
          followingLite: data.followingLite,
          isFollowing: data.isFollowing,
          username: data.username,
          profileImage: data.profile_image,
          bookmarkCount: data.bookmark_count,
          postCount: data.post_count,
          followerCount: data.follower_count,
          followingCount: data.following_count
        });
      });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.setScrollPosition);
  }

  setScrollPosition() {
    let position = window.pageYOffset;
    this.setState({ scrollTo: position });
  }

  beforeListFetch() {
    if (this.state.requestSent) return;

    if (this.state.cmp === "bookmark") {
      setTimeout(this.fetchBookmarkedPostList, 2000);
      this.setState({
        requestSent: true,
        bookmarkLimit: this.state.bookmarkLimit + 10
      });
    } else {
      setTimeout(this.fetchPostList, 2000);
      this.setState({
        requestSent: true,
        postLimit: this.state.postLimit + 10
      });
    }
  }

  fetchPostList() {
    fetch(
      `${this.props.apiROOT}post/userPost/${this.props.match.params.user}/${this.state.postLimit}`
    )
      .then(res => res.json())
      .then(data => {
        this.setState({
          posts: this.state.posts.concat(data.posts)
        });
        if (data.posts.length > 0) {
          this.setState({
            requestSent: false
          });
        }
      });
  }

  fetchBookmarkedPostList() {
    fetch(
      `${this.props.apiROOT}post/bookmarkedPost/${this.props.match.params.user}/${this.state.bookmarkLimit}`
    )
      .then(res => res.json())
      .then(data => {
        this.setState({
          posts: this.state.posts.concat(data.posts)
        });
        if (data.posts.length > 0) {
          this.setState({
            requestSent: false
          });
        }
      });
  }

  componentWillUpdate(nextProp) {
    if (
      this.props.match.params.user !== nextProp.match.params.user ||
      this.props.match.params.suser !== nextProp.match.params.suser
    ) {
      const { user, suser } = nextProp.match.params;

      fetch(`${this.props.apiROOT}user/${user}/${suser}`)
        .then(res => res.json())
        .then(data => {
          this.setState({
            cmp: data.cmp,
            posts: data.posts,
            following: data.following,
            followers: data.followers,
            followingLite: data.followingLite,
            isFollowing: data.isFollowing,
            followerCount: data.follower_count,
            followingCount: data.following_count,
            postCount: data.post_count,
            bookmarkCount: data.bookmark_count,
            userID: data.user_id,
            profileImage: data.profile_image,
            username: data.username
          });
        });
    }
  }

  render() {
    return (
      <section className="user-page-column">
        <div className="user-details-section">
          {this.state.profileImage === "" && (
            <div
              className="user-profile-image img"
              style={{
                backgroundImage:
                  "url(" +
                  this.props.root +
                  "public/images/profile_pic/avatar.jpg)"
              }}
            >
              <img className="img-decoy" alt={this.state.username} />
            </div>
          )}

          {this.state.profileImage !== "" && (
            <div
              className="user-profile-image img"
              style={{
                backgroundImage:
                  "url(" +
                  this.props.root +
                  "public/images/profile_pic/" +
                  this.state.profileImage +
                  ")"
              }}
            >
              <img className="img-decoy" alt={this.state.username} />
            </div>
          )}

          <div className="user-username-div">
            <p className="user-username">{this.state.username}</p>
          </div>

          <div className="clear-float" />
        </div>

        {parseInt(this.state.userID) ===
          parseInt(store.getState().columnOne.details.user_id) && (
            <div className="user-menus">
              <Link
                to={`/user/${this.state.username.replace(/ /g, "-")}-${parseInt(
                  this.state.userID
                )}/`}
              >
                <button
                  style={
                    this.props.match.params.suser === undefined
                      ? { background: "#017301c2" }
                      : {}
                  }
                >
                  Posts <span>{this.state.postCount}</span>
                </button>
              </Link>

              {parseInt(this.state.userID) ===
                parseInt(store.getState().columnOne.details.user_id) && (
                  <Link
                    to={`/user/${this.state.username.replace(/ /g, "-")}-${parseInt(
                      this.state.userID
                    )}/bookmark`}
                  >
                    <button
                      className="user-bookmark-count"
                      style={
                        this.props.match.params.suser === "bookmark"
                          ? { background: "#017301c2" }
                          : {}
                      }
                    >
                      Bookmarks <span>{this.state.bookmarkCount}</span>
                    </button>
                  </Link>
                )}

              {parseInt(this.state.userID) ===
                parseInt(store.getState().columnOne.details.user_id) && (
                  <Link to="/user/editProfile">
                    <button className=" btn">Edit <span>Profile</span> </button>
                  </Link>
                )}

              <a href={`${this.props.root}logout`}>
                <button className="btn ">Logout</button>
              </a>
            </div>
          )}

        {this.state.cmp === "" && (
          <div className="user-menu-posts">
            <Posts
              posts={this.state.posts}
              pageName="user"
              apiROOT={this.props.apiROOT}
              root={this.props.root}
              beforeListFetch={this.beforeListFetch}
            />
          </div>
        )}

        {this.state.cmp === "follower" && (
          <div className="user-menu-details">
            <Follower
              apiROOT={this.props.apiROOT}
              root={this.props.root}
              toggleFollow={this.toggleFollowFromList}
              followers={this.state.followers}
              followingLite={this.state.followingLite}
            />
          </div>
        )}

        {this.state.cmp === "following" && (
          <div className="user-menu-details">
            <Following
              apiROOT={this.props.apiROOT}
              root={this.props.root}
              toggleFollow={this.toggleFollowFromList}
              following={this.state.following}
            />
          </div>
        )}

        {this.state.cmp === "bookmark" && (
          <div className="user-menu-posts">
            <Posts
              posts={this.state.posts}
              pageName="user"
              apiROOT={this.props.apiROOT}
              root={this.props.root}
              beforeListFetch={this.beforeListFetch}
            />
          </div>
        )}
      </section>
    );
  }
}

export default User;
